import { Translations } from '../types';

export const dutchTranslations: Translations = {
  // App title and navigation
  'app.title': 'Route Planner',
  'app.subtitle': 'Toegankelijke routes voor rolstoelgebruikers',
  'nav.home': 'Home',
  'nav.routes': 'Routes',
  'nav.settings': 'Instellingen',
  'nav.help': 'Hulp',

  // Route planning
  'route.start': 'Startpunt',
  'route.end': 'Bestemming',
  'route.plan': 'Route plannen',
  'route.clear': 'Wissen',
  'route.distance': 'Afstand',
  'route.duration': 'Reistijd',
  'route.accessibility': 'Toegankelijkheid',
  'route.unavailable':
    'Routeberekening is niet beschikbaar. Probeer het later opnieuw.',

  // Accessibility constraints
  'constraints.title': 'Toegankelijkheidsvoorkeuren',
  'constraints.avoidStairs': 'Trap vermijden',
  'constraints.avoidSteepSlopes': 'Steile hellingen vermijden',
  'constraints.preferWidePaths': 'Voorkeur voor brede paden',
  'constraints.avoidCobblestones': 'Kinderkopjes vermijden',
  'constraints.requireElevators': 'Liften vereisen',
  'constraints.maxSlope': 'Maximale hellingshoek',
  'constraints.minWidth': 'Minimale padbreedte',

  // Accessibility info
  'accessibility.hasRamp': 'Heeft hellingbaan',
  'accessibility.hasElevator': 'Heeft lift',
  'accessibility.hasAccessibleToilet': 'Heeft toegankelijk toilet',
  'accessibility.pathWidth': 'Padbreedte',
  'accessibility.surfaceType': 'Ondergrond',
  'accessibility.slopeAngle': 'Hellingshoek',
  'accessibility.hasStairs': 'Heeft trappen',

  // Surface types
  'surface.smooth': 'Glad',
  'surface.cobblestone': 'Kinderkopjes',
  'surface.gravel': 'Grind',
  'surface.grass': 'Gras',
  'surface.unknown': 'Onbekend',

  // Warnings and messages
  'warning.stairs': 'Waarschuwing: Trappen op deze route',
  'warning.steepSlope': 'Waarschuwing: Steile helling',
  'warning.narrowPath': 'Waarschuwing: Smal pad',
  'warning.cobblestones': 'Waarschuwing: Kinderkopjes',
  'warning.noElevator': 'Waarschuwing: Geen lift beschikbaar',

  // Buttons and actions
  'button.start': 'Start',
  'button.stop': 'Stop',
  'button.pause': 'Pauzeer',
  'button.resume': 'Hervat',
  'button.details': 'Details',
  'button.share': 'Delen',
  'button.save': 'Opslaan',
  'button.cancel': 'Annuleren',
  'button.confirm': 'Bevestigen',
  'button.back': 'Terug',
  'button.next': 'Volgende',

  // Settings
  'settings.title': 'Instellingen',
  'settings.language': 'Taal',
  'settings.units': 'Eenheden',
  'settings.voiceGuidance': 'Spraakbegeleiding',
  'settings.highContrast': 'Hoog contrast',
  'settings.fontSize': 'Lettergrootte',
  'settings.accessibility': 'Toegankelijkheid',

  // Units
  'unit.meters': 'meter',
  'unit.kilometers': 'kilometer',
  'unit.minutes': 'minuten',
  'unit.hours': 'uren',
  'unit.degrees': 'graden',

  // Status messages
  'status.loading': 'Laden...',
  'status.calculating': 'Route berekenen...',
  'status.noRoute': 'Geen route gevonden',
  'status.error': 'Er is een fout opgetreden',
  'status.success': 'Route gevonden',

  // Address search
  'address.noResults': 'Geen adressen gevonden',

  // Placeholder text
  'placeholder.startLocation': 'Voer startpunt in...',
  'placeholder.endLocation': 'Voer bestemming in...',
  'placeholder.search': 'Zoeken...',

  // Accessibility labels
  'aria.map': 'Kaart met route',
  'aria.routeList': 'Lijst van routes',
  'aria.constraints': 'Toegankelijkheidsvoorkeuren',
  'aria.settings': 'Instellingen',
  'aria.menu': 'Hoofdmenu',
  'aria.close': 'Sluiten',
  'aria.open': 'Openen',

  // Help text
  'help.constraints': 'Stel uw toegankelijkheidsvoorkeuren in voor betere routes',
  'help.map': 'Gebruik de kaart om uw route te plannen en te bekijken',
  'help.voice': 'Schakel spraakbegeleiding in voor hands-free navigatie',

  // Onboarding
  'onboarding.title': 'Onboarding',
  'onboarding.wheelchair.title': 'Jouw rolstoel',
  'onboarding.wheelchair.description': 'Voor een optimale route hebben we je rolstoelspecificaties nodig.',
  'onboarding.wheelchair.addButton': 'Rolstoel toevoegen',
  'onboarding.wheelchair.skip': 'Overslaan',
  'onboarding.wheelchair.instruction': 'Welke rolstoel(en) gebruik je? Voeg meerdere toe indien nodig.',
  'onboarding.wheelchair.type': 'Rolstoel type',
  'onboarding.wheelchair.typePlaceholder': 'Type rolstoel',
  'onboarding.wheelchair.brand': 'Rolstoel merk',
  'onboarding.wheelchair.brandPlaceholder': 'Zoeken...',
  'onboarding.wheelchair.nextStep': 'Volgende stap',
  'onboarding.wheelchair.dimensionsTitle': 'Gemiddelde afmetingen voor een {brand} {type} rolstoel. Pas aan indien nodig.',
  'onboarding.wheelchair.totalWidth': 'Totale breedte',
  'onboarding.wheelchair.totalLength': 'Totale lengte',
  'onboarding.wheelchair.save': 'Rolstoel opslaan',
  'onboarding.wheelchair.addAnother': 'Nog een rolstoel toevoegen',
  'onboarding.wheelchair.finish': 'Voltooien',
  'onboarding.wheelchair.select': 'Selecteer rolstoel',
  'onboarding.wheelchair.added': 'Toegevoegde rolstoelen:',

  // Wheelchair types
  'wheelchair.label': 'rolstoel',
  'wheelchair.type.manual': 'Handbewogen rolstoel',
  'wheelchair.type.electric': 'Elektrische rolstoel',
  'wheelchair.type.sport': 'Sportrolstoel',
  'wheelchair.type.power': 'Elektrische rolstoel (Power)',
  'wheelchair.type.standing': 'Staande rolstoel',
  'wheelchair.type.custom': 'Aangepaste rolstoel',

  // Common wheelchair brands
  'wheelchair.brand.invacare': 'Invacare',
  'wheelchair.brand.quickie': 'Quickie',
  'wheelchair.brand.permobil': 'Permobil',
  'wheelchair.brand.sunrise': 'Sunrise Medical',
  'wheelchair.brand.ottobock': 'Ottobock',
  'wheelchair.brand.pride': 'Pride Mobility',
  'wheelchair.brand.other': 'Anders',

  // Preference onboarding
  'preferences.title': 'Onboarding',
  'preferences.question': 'Vraag {current}/{total}',
  'preferences.description': 'We vragen dit dagelijks om onze AI-routes slimmer en persoonlijker te maken. Zodra we je voorkeuren en routines goed kennen, stoppen we met deze vragen.',
  'preferences.noPreferences': 'Geen voorkeuren ingesteld',

  // Question 1: Route type
  'preferences.routeType.question': 'Wil je de snelste route of de mooiste route?',
  'preferences.routeType.fastest': 'Snelste route',
  'preferences.routeType.beautiful': 'Mooiste route',
  'preferences.routeType.balanced': 'Gebalanceerde route',

  // Question 2: Path preference
  'preferences.pathPreference.question': 'Geef je de voorkeur aan stoepen of fietspaden?',
  'preferences.pathPreference.bikepath': 'Fietspad',
  'preferences.pathPreference.sidewalk': 'Stoep',
  'preferences.pathPreference.noPreference': 'Geen voorkeur',

  // Question 3: Public transport
  'preferences.publicTransport.question': 'Voorkeur voor routes met toegankelijk OV?',
  'preferences.publicTransport.yes': 'Ja',
  'preferences.publicTransport.noPreference': 'Geen voorkeur',

  // Icons
  'icon.rocket': '🚀',
  'icon.mountain': '🏔️',
  'icon.bicycle': '🚲',
  'icon.walking': '🚶',

  // Generate page
  'generate.title': 'Generate',
  'generate.wheelchair.title': 'Jouw rolstoel',
  'generate.wheelchair.previous': 'Vorige rolstoel',
  'generate.wheelchair.next': 'Volgende rolstoel',
  'generate.preferences.title': 'Route voorkeuren vandaag:',
  'generate.preferences.edit': 'edit',
  'generate.whereTo.title': 'Waar naartoe?',
  'generate.location.label': 'Jouw locatie',
  'generate.destination.placeholder': 'Zoeken...',
  'generate.button': 'Genereer route',
  'generate.backToOnboarding': 'Terug naar onboarding',
  'generate.back': 'Terug',

  // Preferences popup
  'preferences.popup.title': 'Voorkeuren',
  'preferences.popup.instruction': 'Werk je route voorkeuren bij:',
  'preferences.popup.save': 'Opslaan',
  'preferences.popup.reorder': 'Herschik je voorkeuren door te slepen',

  // Route preference options
  'preferences.fastest': 'Snelste route',
  'preferences.bikepaths': 'Fietspaden',
  'preferences.accessiblePT': 'Dichtbij toegankelijk OV',
  'preferences.sidewalks': 'Stoepen',
  'preferences.beautiful': 'Mooiste route',

  // Language
  'language.dutch': 'Nederlands',
  'language.english': 'English',

  // Route Results Page
  'routeResults.start': 'Start',
  'routeResults.destination': 'Bestemming',
  'routeResults.crossings': 'oversteken',
  'routeResults.totalTime': 'totaal',
  'routeResults.crossingsLabel': 'Oversteken',
  'routeResults.decreaseCrossings': 'Oversteken verminderen',
  'routeResults.increaseCrossings': 'Oversteken vermeerderen',
  'routeResults.decreaseBikepath': 'Fietspad verminderen',
  'routeResults.increaseBikepath': 'Fietspad vermeerderen',
  'routeResults.decreaseSidewalk': 'Stoep verminderen',
  'routeResults.increaseSidewalk': 'Stoep vermeerderen',
  'routeResults.bikepathLabel': 'Fietspad',
  'routeResults.sidewalkLabel': 'Stoep',
  'routeResults.previousRoute': 'Vorige route',
  'routeResults.currentRoute': 'Huidige route',
  'routeResults.viewingPreviousRoute': 'Bekijken vorige route',
  'routeResults.faster': 'sneller',
  'routeResults.slower': 'langzamer',
  'routeResults.sameDuration': 'Zelfde duur als vorige route',

  // Map explainer (how it works)
  'mapExplainer.open': 'Hoe het werkt — informatie',
  'mapExplainer.title': 'Hoe werkt het?',
  'mapExplainer.close': 'Sluiten',
  'mapExplainer.algorithmTitle': 'Ons algoritme',
  'mapExplainer.algorithmBody':
    'Deze app gebruikt het routeplanning-algoritme van de Gemeente Amsterdam. Routes zijn afgestemd op toegankelijkheid voor rolstoelgebruikers op basis van effectieve loopruimte en uw voorkeuren.',
  'mapExplainer.dataTitle': 'De data',
  'mapExplainer.dataBody1':
    'De loopruimte (bewegingsvrijheid) die in deze app wordt getoond, is een schatting op basis van het open-source algoritme van de Gemeente Amsterdam. De effectieve loopruimte wordt berekend door obstakels zoals bomen, vuilcontainers, straatlantaarns en bankjes van de totale stoepbreedte af te trekken. Dit geeft een indicatie van de ruimte die beschikbaar is voor rolstoelgebruikers.',
  'mapExplainer.dataBody2':
    'Het routeplanning-algoritme gebruikt alleen straten met een effectieve loopruimte van 80 cm of meer.',
  'mapExplainer.limitationsIntro': 'Houd rekening met de volgende beperkingen:',
  'mapExplainer.limitationOutdatedLabel': 'Verouderde gegevens:',
  'mapExplainer.limitationOutdatedBody':
    'De onderliggende data wordt één keer per jaar verzameld. De situatie ter plaatse kan sindsdien zijn veranderd.',
  'mapExplainer.limitationWorksLabel': 'Werkzaamheden:',
  'mapExplainer.limitationWorksBody':
    'Tijdelijke obstakels zoals bouwwerkzaamheden of steigers worden mogelijk niet weergegeven als deze nog niet aanwezig waren tijdens de dataverzameling.',

  // Feedback Modal
  'feedback.title': 'Beoordeel je route',
  'feedback.routeInfo': '{start} naar {end} op {date}',
  'feedback.additionalQuestion': 'Wil je nog iets toevoegen?',
  'feedback.commentsPlaceholder': 'Voeg hier je opmerkingen toe...',
  'feedback.skip': 'Overslaan',
  
  // Feedback tags
  'feedback.tag.busy': 'Druk',
  'feedback.tag.parkedBikes': 'Fout geparkeerde fietsen',
  'feedback.tag.fewRestPlaces': 'Te weinig rustplekken',
  'feedback.tag.narrowSidewalk': 'Smalle stoep',
  'feedback.tag.manyCrossings': 'Te veel oversteekpunten',

  // Navigation Mode
  'navigation.start': 'Start navigatie',
  'navigation.navigatingTo': 'Navigeren naar',
  'navigation.soundOn': 'Geluid aan',
  'navigation.soundOff': 'Geluid uit',
  'navigation.pause': 'Pauzeren',
  'navigation.resume': 'Hervatten',
  'navigation.stop': 'Stop navigatie',
  'navigation.destination': 'Bestemming',
  'navigation.currentLocation': 'Je huidige locatie',
  'navigation.completed': 'voltooid',
  'navigation.paused': 'Gepauzeerd',
  'navigation.navigating': 'Navigeren',
  'navigation.eta': 'ETA',
  'navigation.remaining': 'resterend',
  'navigation.end': 'Beëindig navigatie',
  'navigation.goSouth': 'Ga zuidwaarts',
  'navigation.turnLeft': 'Sla linksaf',
  'navigation.turnRight': 'Sla rechtsaf',
  'navigation.goStraight': 'Ga rechtdoor',
  'navigation.arrived': 'Je bent aangekomen op je bestemming',
};

export const englishTranslations: Translations = {
  // App title and navigation
  'app.title': 'Route Planner',
  'app.subtitle': 'Accessible routes for wheelchair users',
  'nav.home': 'Home',
  'nav.routes': 'Routes',
  'nav.settings': 'Settings',
  'nav.help': 'Help',

  // Route planning
  'route.start': 'Start point',
  'route.end': 'Destination',
  'route.plan': 'Plan route',
  'route.clear': 'Clear',
  'route.distance': 'Distance',
  'route.duration': 'Travel time',
  'route.accessibility': 'Accessibility',
  'route.unavailable':
    'Route calculation is not available. Please try again later.',

  // Accessibility constraints
  'constraints.title': 'Accessibility preferences',
  'constraints.avoidStairs': 'Avoid stairs',
  'constraints.avoidSteepSlopes': 'Avoid steep slopes',
  'constraints.preferWidePaths': 'Prefer wide paths',
  'constraints.avoidCobblestones': 'Avoid cobblestones',
  'constraints.requireElevators': 'Require elevators',
  'constraints.maxSlope': 'Maximum slope angle',
  'constraints.minWidth': 'Minimum path width',

  // Accessibility info
  'accessibility.hasRamp': 'Has ramp',
  'accessibility.hasElevator': 'Has elevator',
  'accessibility.hasAccessibleToilet': 'Has accessible toilet',
  'accessibility.pathWidth': 'Path width',
  'accessibility.surfaceType': 'Surface type',
  'accessibility.slopeAngle': 'Slope angle',
  'accessibility.hasStairs': 'Has stairs',

  // Surface types
  'surface.smooth': 'Smooth',
  'surface.cobblestone': 'Cobblestone',
  'surface.gravel': 'Gravel',
  'surface.grass': 'Grass',
  'surface.unknown': 'Unknown',

  // Warnings and messages
  'warning.stairs': 'Warning: Stairs on this route',
  'warning.steepSlope': 'Warning: Steep slope',
  'warning.narrowPath': 'Warning: Narrow path',
  'warning.cobblestones': 'Warning: Cobblestones',
  'warning.noElevator': 'Warning: No elevator available',

  // Buttons and actions
  'button.start': 'Start',
  'button.stop': 'Stop',
  'button.pause': 'Pause',
  'button.resume': 'Resume',
  'button.details': 'Details',
  'button.share': 'Share',
  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.confirm': 'Confirm',
  'button.back': 'Back',
  'button.next': 'Next',

  // Settings
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.units': 'Units',
  'settings.voiceGuidance': 'Voice guidance',
  'settings.highContrast': 'High contrast',
  'settings.fontSize': 'Font size',
  'settings.accessibility': 'Accessibility',

  // Units
  'unit.meters': 'meters',
  'unit.kilometers': 'kilometers',
  'unit.minutes': 'minutes',
  'unit.hours': 'hours',
  'unit.degrees': 'degrees',

  // Status messages
  'status.loading': 'Loading...',
  'status.calculating': 'Calculating route...',
  'status.noRoute': 'No route found',
  'status.error': 'An error occurred',
  'status.success': 'Route found',

  // Address search
  'address.noResults': 'No addresses found',

  // Placeholder text
  'placeholder.startLocation': 'Enter start point...',
  'placeholder.endLocation': 'Enter destination...',
  'placeholder.search': 'Search...',

  // Accessibility labels
  'aria.map': 'Map with route',
  'aria.routeList': 'List of routes',
  'aria.constraints': 'Accessibility preferences',
  'aria.settings': 'Settings',
  'aria.menu': 'Main menu',
  'aria.close': 'Close',
  'aria.open': 'Open',

  // Help text
  'help.constraints': 'Set your accessibility preferences for better routes',
  'help.map': 'Use the map to plan and view your route',
  'help.voice': 'Enable voice guidance for hands-free navigation',

  // Onboarding
  'onboarding.title': 'Onboarding',
  'onboarding.wheelchair.title': 'Your wheelchair',
  'onboarding.wheelchair.description': 'For an optimal route, we need your wheelchair specifications.',
  'onboarding.wheelchair.addButton': 'Add wheelchair',
  'onboarding.wheelchair.skip': 'Skip',
  'onboarding.wheelchair.instruction': 'Which wheelchair(s) do you use? Add multiple if needed.',
  'onboarding.wheelchair.type': 'Wheelchair type',
  'onboarding.wheelchair.typePlaceholder': 'Wheelchair type',
  'onboarding.wheelchair.brand': 'Wheelchair brand',
  'onboarding.wheelchair.brandPlaceholder': 'Search...',
  'onboarding.wheelchair.nextStep': 'Next step',
  'onboarding.wheelchair.dimensionsTitle': 'Average dimensions for a {brand} {type} wheelchair. Adjust if needed.',
  'onboarding.wheelchair.totalWidth': 'Total width',
  'onboarding.wheelchair.totalLength': 'Total length',
  'onboarding.wheelchair.save': 'Save wheelchair',
  'onboarding.wheelchair.addAnother': 'Add another wheelchair',
  'onboarding.wheelchair.finish': 'Finish',
  'onboarding.wheelchair.select': 'Select wheelchair',
  'onboarding.wheelchair.added': 'Added wheelchairs:',

  // Wheelchair types
  'wheelchair.label': 'wheelchair',
  'wheelchair.type.manual': 'Manual wheelchair',
  'wheelchair.type.electric': 'Electric wheelchair',
  'wheelchair.type.sport': 'Sport wheelchair',
  'wheelchair.type.power': 'Power wheelchair',
  'wheelchair.type.standing': 'Standing wheelchair',
  'wheelchair.type.custom': 'Custom wheelchair',

  // Common wheelchair brands
  'wheelchair.brand.invacare': 'Invacare',
  'wheelchair.brand.quickie': 'Quickie',
  'wheelchair.brand.permobil': 'Permobil',
  'wheelchair.brand.sunrise': 'Sunrise Medical',
  'wheelchair.brand.ottobock': 'Ottobock',
  'wheelchair.brand.pride': 'Pride Mobility',
  'wheelchair.brand.other': 'Other',

  // Preference onboarding
  'preferences.title': 'Onboarding',
  'preferences.question': 'Question {current}/{total}',
  'preferences.description': 'We ask this daily to make our AI routes smarter and more personalized. Once we know your preferences and routines well, we\'ll stop asking these questions.',
  'preferences.noPreferences': 'No preferences set',

  // Question 1: Route type
  'preferences.routeType.question': 'Do you want the fastest route or the most beautiful route?',
  'preferences.routeType.fastest': 'Fastest route',
  'preferences.routeType.beautiful': 'Most beautiful route',
  'preferences.routeType.balanced': 'Balanced route',

  // Question 2: Path preference
  'preferences.pathPreference.question': 'Do you prefer sidewalks or bike paths?',
  'preferences.pathPreference.bikepath': 'Bike path',
  'preferences.pathPreference.sidewalk': 'Sidewalk',
  'preferences.pathPreference.noPreference': 'No preference',

  // Question 3: Public transport
  'preferences.publicTransport.question': 'Preference for routes with accessible public transport?',
  'preferences.publicTransport.yes': 'Yes',
  'preferences.publicTransport.noPreference': 'No preference',

  // Icons
  'icon.rocket': '🚀',
  'icon.mountain': '🏔️',
  'icon.bicycle': '🚲',
  'icon.walking': '🚶',

  // Generate page
  'generate.title': 'Generate',
  'generate.wheelchair.title': 'Your wheelchair',
  'generate.wheelchair.previous': 'Previous wheelchair',
  'generate.wheelchair.next': 'Next wheelchair',
  'generate.preferences.title': 'Route preferences today:',
  'generate.preferences.edit': 'edit',
  'generate.whereTo.title': 'Where to?',
  'generate.location.label': 'Your location',
  'generate.destination.placeholder': 'Search...',
  'generate.button': 'Generate route',
  'generate.backToOnboarding': 'Back to onboarding',
  'generate.back': 'Back',

  // Preferences popup
  'preferences.popup.title': 'Preferences',
  'preferences.popup.instruction': 'Update your route preferences:',
  'preferences.popup.save': 'Save',
  'preferences.popup.reorder': 'Reorder your preferences by dragging',

  // Route preference options
  'preferences.fastest': 'Fastest route',
  'preferences.bikepaths': 'Bike paths',
  'preferences.accessiblePT': 'Near accessible PT',
  'preferences.sidewalks': 'Sidewalks',
  'preferences.beautiful': 'Most beautiful route',

  // Language
  'language.dutch': 'Nederlands',
  'language.english': 'English',

  // Route Results Page
  'routeResults.start': 'Start',
  'routeResults.destination': 'Destination',
  'routeResults.crossings': 'crossings',
  'routeResults.totalTime': 'total',
  'routeResults.crossingsLabel': 'Crossings',
  'routeResults.decreaseCrossings': 'Decrease crossings',
  'routeResults.increaseCrossings': 'Increase crossings',
  'routeResults.decreaseBikepath': 'Decrease bike path',
  'routeResults.increaseBikepath': 'Increase bike path',
  'routeResults.decreaseSidewalk': 'Decrease sidewalk',
  'routeResults.increaseSidewalk': 'Increase sidewalk',
  'routeResults.bikepathLabel': 'Bike path',
  'routeResults.sidewalkLabel': 'Sidewalk',
  'routeResults.previousRoute': 'Previous route',
  'routeResults.currentRoute': 'Current route',
  'routeResults.viewingPreviousRoute': 'Viewing previous route',
  'routeResults.faster': 'faster',
  'routeResults.slower': 'slower',
  'routeResults.sameDuration': 'Same duration as previous route',

  // Map explainer (how it works)
  'mapExplainer.open': 'How it works — information',
  'mapExplainer.title': 'How does it work?',
  'mapExplainer.close': 'Close',
  'mapExplainer.algorithmTitle': 'Our algorithm',
  'mapExplainer.algorithmBody':
    'This app uses the City of Amsterdam’s route planning algorithm. Routes are tuned for wheelchair users based on effective walking space and your preferences.',
  'mapExplainer.dataTitle': 'The data',
  'mapExplainer.dataBody1':
    'The walking space (freedom of movement) shown in this app is an estimate based on the City of Amsterdam’s open-source algorithm. Effective walking space is calculated by subtracting obstacles such as trees, waste containers, street lights and benches from total sidewalk width. This indicates the space available for wheelchair users.',
  'mapExplainer.dataBody2':
    'The route planning algorithm only uses streets with an effective walking space of 80 cm or more.',
  'mapExplainer.limitationsIntro': 'Please keep the following limitations in mind:',
  'mapExplainer.limitationOutdatedLabel': 'Outdated data:',
  'mapExplainer.limitationOutdatedBody':
    'The underlying data is collected once a year. The situation on the ground may have changed since then.',
  'mapExplainer.limitationWorksLabel': 'Construction:',
  'mapExplainer.limitationWorksBody':
    'Temporary obstacles such as construction work or scaffolding may not be shown if they were not yet present during data collection.',

  // Feedback Modal
  'feedback.title': 'Rate your route',
  'feedback.routeInfo': '{start} to {end} on {date}',
  'feedback.additionalQuestion': 'Would you like to add anything?',
  'feedback.commentsPlaceholder': 'Add your comments here...',
  'feedback.skip': 'Skip',
  
  // Feedback tags
  'feedback.tag.busy': 'Busy',
  'feedback.tag.parkedBikes': 'Poorly parked bikes',
  'feedback.tag.fewRestPlaces': 'Too few rest places',
  'feedback.tag.narrowSidewalk': 'Narrow sidewalk',
  'feedback.tag.manyCrossings': 'Too many crossings',

  // Navigation Mode
  'navigation.start': 'Start navigation',
  'navigation.navigatingTo': 'Navigating to',
  'navigation.soundOn': 'Sound on',
  'navigation.soundOff': 'Sound off',
  'navigation.pause': 'Pause',
  'navigation.resume': 'Resume',
  'navigation.stop': 'Stop navigation',
  'navigation.destination': 'Destination',
  'navigation.currentLocation': 'Your current location',
  'navigation.completed': 'completed',
  'navigation.paused': 'Paused',
  'navigation.navigating': 'Navigating',
  'navigation.eta': 'ETA',
  'navigation.remaining': 'remaining',
  'navigation.end': 'End navigation',
  'navigation.goSouth': 'Go south',
  'navigation.turnLeft': 'Turn left',
  'navigation.turnRight': 'Turn right',
  'navigation.goStraight': 'Go straight',
  'navigation.arrived': 'You have arrived at your destination',
};
